import {
  CriticalIllnessNY,
  matchCriticalIllnessNYByType,
} from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/CriticalIllnessNY';
import * as G from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/GroupCriticalIllnessNY';
import * as NY from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/NewYorkCriticalIllnessNY';
import * as O from 'ApplicationEntry/models/ProductsRiders/CriticalIllnessNY/OrdinaryCriticalIllnessNY';
import {Async, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum CriticalIllnessNYActionType {
  CHANGE_PLAN_TYPE = 'criticalIllnessNY/CHANGE_PLAN_TYPE',
  CHANGE_BENEFIT_AMOUNT = 'criticalIllnessNY/CHANGE_BENEFIT_AMOUNT',
  CHANGE_PREMIUM = 'criticalIllnessNY/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'criticalIllnessNY/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'criticalIllnessNY/CHANGE_CWA',
  CHANGE_INSURED_SC = 'criticalIllnessNY/CHANGE_INSURED_SC',
  CHANGE_SPOUSE_SC = 'criticalIllnessNY/CHANGE_SPOUSE_SC',
  CHANGE_SECTION125 = 'criticalIllnessNY/CHANGE_SECTION125',
  CHANGE_REPLACEMENT = 'criticalIllnessNY/CHANGE_REPLACEMENT',
  CHANGE_POLICY_NUMBER = 'criticalIllnessNY/CHANGE_POLICY_NUMBER',
  CHANGE_SITUS_STATE = 'criticalIllnessNY/CHANGE_SITUS_STATE',
  CHANGE_WELLNESS_UNITS = 'criticalIllnessNY/CHANGE_WELLNESS_UNITS',
  CHANGE_CI_OPTION = 'criticalIllnessNY/CHANGE_CI_OPTION',
  CHANGE_SECOND_EVENT_CI = 'criticalIllnessNY/CHANGE_SECOND_EVENT_CI',
  CHANGE_J_STAMP = 'criticalIllnessNY/CHANGE_J_STAMP',
  CHANGE_PACKAGE_SOURCE = 'criticalIllnessNY/CHANGE_PACKAGE_SOURCE',
  GET_PACKAGE_SOURCE_LIST = 'criticalIllnessNY/GET_PACKAGE_SOURCE_LIST',
  CHANGE_PACKAGE_SOURCE_LIST = 'criticalIllnessNY/CHANGE_PACKAGE_SOURCE_LIST',
}

export const isCriticalIllnessNYAction = (action: any): action is CriticalIllnessNYAction =>
  action.type in reverseEnum(CriticalIllnessNYActionType);

export const changePlanType = (planType: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_PLAN_TYPE, {planType});
export const changeBenefitAmount = (benefitAmount: number) =>
  createAction(CriticalIllnessNYActionType.CHANGE_BENEFIT_AMOUNT, {benefitAmount});
export const changePremium = (premium: string) => createAction(CriticalIllnessNYActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(CriticalIllnessNYActionType.CHANGE_CWA, {cwa});
export const changeInsuredSC = (insuredSC: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_INSURED_SC, {insuredSC});
export const changeSpouseSC = (spouseSC: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_SPOUSE_SC, {spouseSC});
export const changeSection125 = (section125: boolean) =>
  createAction(CriticalIllnessNYActionType.CHANGE_SECTION125, {section125});
export const changeReplacement = (replacement: boolean) =>
  createAction(CriticalIllnessNYActionType.CHANGE_REPLACEMENT, {replacement});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeSitusState = (situsState: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_SITUS_STATE, {situsState});
export const changeWellnessUnits = (wellnessUnits: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_WELLNESS_UNITS, {wellnessUnits});
export const changeCIOption = (ciOption: boolean) =>
  createAction(CriticalIllnessNYActionType.CHANGE_CI_OPTION, {ciOption});
export const changeSecondEventCI = (secondEventCI: boolean) =>
  createAction(CriticalIllnessNYActionType.CHANGE_SECOND_EVENT_CI, {secondEventCI});
export const changeJStamp = (jStamp: boolean) => createAction(CriticalIllnessNYActionType.CHANGE_J_STAMP, {jStamp});
export const changePackageSource = (packageSource: string) =>
  createAction(CriticalIllnessNYActionType.CHANGE_PACKAGE_SOURCE, {packageSource});
export const getPackageSourceList = (caseNumber: string, planCode: string) =>
  createAction(CriticalIllnessNYActionType.GET_PACKAGE_SOURCE_LIST, {caseNumber, planCode});
export const changePackageSourceApi = (packageSourceList: Async<object[]>) =>
  createAction(CriticalIllnessNYActionType.CHANGE_PACKAGE_SOURCE_LIST, {packageSourceList});

export type CriticalIllnessNYAction =
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof changeBenefitAmount>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeInsuredSC>
  | ReturnType<typeof changeSpouseSC>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeWellnessUnits>
  | ReturnType<typeof changeCIOption>
  | ReturnType<typeof changeSecondEventCI>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changePackageSource>
  | ReturnType<typeof getPackageSourceList>
  | ReturnType<typeof changePackageSourceApi>;

type CriticalIllnessNYState = CriticalIllnessNY;

export default (state: CriticalIllnessNYState, action: CriticalIllnessNYAction): CriticalIllnessNYState => {
  switch (action.type) {
    case CriticalIllnessNYActionType.CHANGE_PLAN_TYPE:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changePlanType(action.payload.planType),
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_BENEFIT_AMOUNT:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeBenefitAmount(action.payload.benefitAmount),
        Group: G.changeBenefitAmount(action.payload.benefitAmount),
        NewYork: NY.changeBenefitAmount(action.payload.benefitAmount),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_PREMIUM:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_CALCULATED_PREMIUM:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_CWA:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_INSURED_SC:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeInsuredSC(action.payload.insuredSC),
        Group: G.changeInsuredSC(action.payload.insuredSC),
        NewYork: NY.changeInsuredSC(action.payload.insuredSC),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_SPOUSE_SC:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeSpouseSC(action.payload.spouseSC),
        Group: G.changeSpouseSC(action.payload.spouseSC),
        NewYork: NY.changeSpouseSC(action.payload.spouseSC),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_SECTION125:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeSection125(action.payload.section125),
        Group: G.changeSection125(action.payload.section125),
        NewYork: NY.changeSection125(action.payload.section125),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_REPLACEMENT:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        NewYork: NY.changeReplacement(action.payload.replacement),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_POLICY_NUMBER:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Ordinary: O.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        Group: G.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        NewYork: NY.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
      })(state);
    case CriticalIllnessNYActionType.CHANGE_SITUS_STATE:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changeSitusState(action.payload.situsState),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.CHANGE_WELLNESS_UNITS:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changeWellnessUnit(action.payload.wellnessUnits),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.CHANGE_CI_OPTION:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changeCIOption(action.payload.ciOption),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.CHANGE_SECOND_EVENT_CI:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changeSecondEventCI(action.payload.secondEventCI),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.CHANGE_J_STAMP:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changeJStamp(action.payload.jStamp),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.CHANGE_PACKAGE_SOURCE:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changePackageSource(action.payload.packageSource),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.GET_PACKAGE_SOURCE_LIST:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changePackageSourceList(new Loading()),
        _: () => state,
      })(state);
    case CriticalIllnessNYActionType.CHANGE_PACKAGE_SOURCE_LIST:
      return matchCriticalIllnessNYByType<CriticalIllnessNY>({
        Group: G.changePackageSourceList(action.payload.packageSourceList),
        _: () => state,
      })(state);
    default:
      return state;
  }
};
